/**
 * Operator details for the privacy policy and terms of use — the one place to
 * change them. The texts themselves are generated from docs/legal in the
 * workspace root (see legalTexts.ts).
 */
export const OPERATOR_NAME = "east173";
export const OPERATOR_CONTACT = "office@east173.com";
